import { Button, message, Radio, RadioChangeEvent, Space } from "antd";
import React, { useEffect, useState } from "react";

interface Address {
  addressType: string;
  gstNumber: string;
  businessName: string;
  alternateNumber: string;
  buildingAndBlockNumber: string;
  email: string;
  firstName: string;
  houseNumberAndFloor: string;
  landmark: string;
  lastName: string;
  locality: string;
  phoneNumber: string;
  pincode: string;
}

interface ShippingAddressProps {
  isAddress: Address;
  initialData: Address;
  isSaved: boolean;
  onSave: (updatedAddress: {
    shippingAddress?: Address;
    gstAddress?: Address;
  }) => void; // Accept either shippingAddress or gstAddress
  enableButton: () => void;
  setIsAddress: React.Dispatch<React.SetStateAction<Address>>;
}

const ShippingAddress: React.FC<ShippingAddressProps> = ({
  isAddress,
  isSaved,
  setIsAddress,
  enableButton,
  initialData,
  onSave,
}) => {
  const [selectedDeliveryType, setSelectedDeliveryType] =
    useState<string>("SameAddress");

  const [formData, setFormData] = useState<Address>(initialData);
  const [messageApi, contextHolder] = message.useMessage();
  const [AddType, setAddType] = useState("Work");

  const success = (content: any) => {
    messageApi.open({
      type: "success",
      content: content,
      className: "custom-class",
    });
  };

  const errormessage = (content: any) => {
    messageApi.open({
      type: "error",
      content: content,
      className: "custom-class",
    });
  };

  const handleSaveClick = () => {
    // Create the address payload based on the selected delivery type
    const addressPayload =
      selectedDeliveryType === "SameAddress"
        ? { shippingAddress: isAddress }
        : selectedDeliveryType === "GSTinvoice"
        ? { gstAddress: isAddress }
        : {};
    localStorage.setItem("address", selectedDeliveryType);

    onSave(addressPayload);

    enableButton();
  };

  useEffect(() => {
    if (isSaved) {
      handleSaveClick();
    }
  }, [isSaved]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    // Debugging: Log before and after updating the state
    setFormData({ ...formData, [name]: value });

    setIsAddress((prev) => {
      const newState = { ...prev, [name]: value };
      return newState;
    });
  };

  const onChangeAddType = (e: RadioChangeEvent) => {
    setAddType(e.target.value);
    setIsAddress({
      ...isAddress,
      addressType: e.target.value,
      locality: "dummy",
    });
  };
  // Handles delivery type radio button changes
  const handleDeliveryTypeChange = (e: RadioChangeEvent) => {
    setSelectedDeliveryType(e.target.value);
  };

  const handleSaveAddress = () => {
    // Call the function to enable the button in the parent component
    enableButton();
  };
  return (
    <>
      {selectedDeliveryType === "SameAddress" && (
        <div>
          <div className="address-box">
            <h6 style={{ fontWeight: 700 }}>Shipping Address</h6>
          </div>
          <div className="row address">
            <div className="col-lg-6">
              <label>
                {" "}
                First Name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                name="firstName"
                value={isAddress.firstName}
                onChange={handleInputChange}
              ></input>
            </div>
            <div className="col-lg-6">
              <label>
                {" "}
                Last Name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                name="lastName"
                value={isAddress.lastName}
                onChange={handleInputChange}
              ></input>
            </div>
            <div className="col-lg-6">
              <label>
                {" "}
                House Number <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={isAddress.houseNumberAndFloor}
                name="houseNumberAndFloor"
                onChange={handleInputChange}
              ></input>
            </div>
            <div className="col-lg-6">
              <label>
                {" "}
                Street <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={isAddress.buildingAndBlockNumber}
                name="buildingAndBlockNumber"
                onChange={handleInputChange}
              ></input>
            </div>
            <div className="col-lg-6">
              <label> Landmark</label>
              <input
                value={isAddress.landmark}
                name="landmark"
                onChange={handleInputChange}
              ></input>
            </div>
            <div className="col-lg-6">
              <label>
                {" "}
                Email <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={isAddress.email}
                name="email"
                onChange={handleInputChange}
              ></input>
            </div>
            <div className="col-lg-6">
              <label>
                {" "}
                Phone Number <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={isAddress.phoneNumber}
                name="phoneNumber"
                onChange={handleInputChange}
              ></input>
            </div>
            <div className="col-lg-6">
              <label> Alternative Number </label>
              <input
                value={isAddress.alternateNumber}
                name="alternateNumber"
                onChange={handleInputChange}
              ></input>
            </div>

            <div className="col-lg-6">
              <label>
                {" "}
                PinCode <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={isAddress.pincode}
                name="pincode"
                onChange={handleInputChange}
              ></input>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
              <div>
                <br />
                <h6 style={{ fontWeight: 700 }}>Address Type</h6>

                <Radio.Group
                  onChange={onChangeAddType}
                  value={isAddress.addressType || AddType}
                >
                  <Radio value={"Home"}>Home</Radio>
                  <Radio value={"Work"}>Work</Radio>
                  <Radio value={"Other"}>Other</Radio>
                </Radio.Group>
              </div>
            </div>
          </div>
        </div>
      )}

      {selectedDeliveryType === "GSTinvoice" && (
        <div>
          <div className="address-box">
            <h6 style={{ fontWeight: 700 }}>GST Invoice Address</h6>
          </div>
          <div className="row address">
            <div className="col-lg-6">
              <label>
                {" "}
                GST Number <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={isAddress.gstNumber}
                name="gstNumber"
                onChange={handleInputChange}
              ></input>
            </div>
            <div className="col-lg-6">
              <label>
                {" "}
                Business Name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={isAddress.businessName}
                name="businessName"
                onChange={handleInputChange}
              ></input>
            </div>
            <div className="col-lg-6">
              <label>
                {" "}
                First Name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={isAddress.firstName}
                name="firstName"
                onChange={handleInputChange}
              ></input>
            </div>
            <div className="col-lg-6">
              <label>
                {" "}
                Last Name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={isAddress.lastName}
                onChange={handleInputChange}
              ></input>
            </div>
            <div className="col-lg-6">
              <label>
                {" "}
                House Number <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={isAddress.houseNumberAndFloor}
                onChange={handleInputChange}
              ></input>
            </div>
            <div className="col-lg-6">
              <label>
                {" "}
                Street <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={isAddress.buildingAndBlockNumber}
                onChange={handleInputChange}
              ></input>
            </div>
            <div className="col-lg-6">
              <label> Landmark</label>
              <input
                value={isAddress.landmark}
                onChange={handleInputChange}
              ></input>
            </div>
            <div className="col-lg-6">
              <label>
                {" "}
                Email <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={isAddress.email}
                onChange={handleInputChange}
              ></input>
            </div>
            <div className="col-lg-6">
              <label>
                {" "}
                Phone Number <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={isAddress.phoneNumber}
                onChange={handleInputChange}
              ></input>
            </div>
            <div className="col-lg-6">
              <label> Alternative Number</label>
              <input
                value={isAddress.alternateNumber}
                onChange={handleInputChange}
              ></input>
            </div>

            <div className="col-lg-6">
              <label>
                {" "}
                PinCode <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={isAddress.pincode}
                onChange={handleInputChange}
              ></input>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
              <div>
                <br />
                <h6 style={{ fontWeight: 700 }}> Address Type</h6>

                <Radio.Group
                  onChange={onChangeAddType}
                  value={isAddress.addressType || AddType}
                >
                  <Radio value={"Home"}>Home</Radio>
                  <Radio value={"Work"}>Work</Radio>
                  <Radio value={"Other"}>Other</Radio>
                </Radio.Group>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="">
        <div>
          <Radio.Group
            onChange={handleDeliveryTypeChange}
            value={selectedDeliveryType}
          >
            <br />
            <Space direction="vertical">
              <h6 style={{ fontWeight: 700 }}>Billing Address</h6>
              <Radio value={"SameAddress"}>Same as Shipping Address </Radio>
              <Radio value={"GSTinvoice"}> GST invoice </Radio>
            </Space>
          </Radio.Group>
        </div>
      </div>
      <Button onClick={handleSaveClick} className="save-add-btn">
        Save Address
      </Button>
    </>
  );
};
export default ShippingAddress;
